'use client';
import { Grid as SharedGrid } from '@launchstore/shared-puck';
import type { GridProps } from '@launchstore/shared-puck';
export const Grid: any = SharedGrid;
export type { GridProps };
export default Grid;
